export default {"src":"/_next/static/media/blog-back-to-the-future.354650a8.gif","height":281,"width":500,"blurWidth":0,"blurHeight":0};